
import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  watch,
  watchEffect,
} from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { fmtMenu } from "../../utils/util";

export default defineComponent({
  components: {},
  emits: ["setLW"],
  setup(props, { emit }) {
    // common
    const cw = ref<number>(48);
    const w = ref<number>(200);
    const width = ref<number>(0);
    // sider shadow
    const siderShadowBox = reactive({
      shadowWidth: w.value,
      shadowCollapsed: false,
      shadowCollapsedWidth: cw.value,
      shadowOnBreakpoint: (broken: boolean) => {
        if (broken) {
          siderShadowBox.shadowCollapsed = true;
          siderShadowBox.shadowCollapsedWidth = 0;
          siderMenuBox.menuCollapsed = true;
          siderMenuBox.menuCollapsedWidth = 0;
          width.value = 0;
        } else {
          siderShadowBox.shadowCollapsedWidth = cw.value;
          siderMenuBox.menuCollapsed = siderShadowBox.shadowCollapsed;
          siderMenuBox.menuCollapsedWidth = cw.value;
          width.value = siderMenuBox.menuCollapsed
            ? siderMenuBox.menuCollapsedWidth
            : w.value;
        }
      },
    });
    // sider menu
    const siderMenuBox = reactive({
      menuCollapsed: false,
      menuCollapsedWidth: cw.value,
      menuOnCollapse: (collapsed: boolean) => {
        let siderWidth = 0;
        if (collapsed) {
          // close
          siderWidth = siderMenuBox.menuCollapsedWidth;
        } else {
          // open
          siderWidth = w.value;
        }
        width.value = siderMenuBox.menuCollapsedWidth === 0 ? 0 : siderWidth;
        siderMenuBox.menuCollapsed = collapsed;
        if (siderMenuBox.menuCollapsedWidth == cw.value) {
          siderShadowBox.shadowCollapsed = collapsed;
        }
      },
    });
    watch(width, (w) => {
      emit("setLW", w);
    });
    // menu
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const menuBox = reactive({
      collapsed: false,
      menu: [] as Record<any, any>,
      selectedKeys: [] as Record<any, any>,
      openKeys: [] as Record<any, any>,
      dynamicKeys: [] as Record<any, any>,
    });
    const formatMenu = () => {
      const menus = store.getters.assnUserMenus;
      menus.unshift({ name: "home", key: "home" });
      const menuDatas: Record<any, any> = fmtMenu(menus, route);
      menuBox.selectedKeys = menuDatas.selected;
      menuBox.openKeys = menuDatas.opened;
      menuBox.menu = menuDatas.data;
      store.commit("setDatas", ["assnUserTitles", menuDatas.titles]);
    };
    watchEffect(() => {
      formatMenu();
    });
    return {
      cw,
      w,
      width,
      ...toRefs(siderShadowBox),
      ...toRefs(siderMenuBox),
      ...toRefs(menuBox),
    };
  },
});
